import { Link } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

/**
 * Shown in place of the "Email … to Customer" button when it can't be offered
 * yet: says which email is missing (the customer's, the shop's, or both) and
 * where to add it. Render only once both lookups have loaded, so it never
 * flashes while data is still on its way.
 */
export function EmailSetupHint({
  kindLabel,
  customerMissing,
  shopMissing,
  customerNumber,
}: {
  /** "estimate" | "invoice" */
  kindLabel: string;
  customerMissing: boolean;
  shopMissing: boolean;
  customerNumber: number;
}) {
  const { session } = useAuth();
  if (!customerMissing && !shopMissing) return null;
  const customerLink = (
    <Link to={`/customers/${customerNumber}/edit`} className="text-[#0f6d86] hover:underline">
      customer record
    </Link>
  );
  // Shop Settings is owner-only, so staff just see the text.
  const shopLink =
    session?.role === "owner" ? (
      <Link to="/settings" className="text-[#0f6d86] hover:underline">
        Shop Settings
      </Link>
    ) : (
      "Shop Settings"
    );
  return (
    <p className="m-0 mt-1 text-[12.5px] leading-snug text-[#8b97a8]">
      Want to email this {kindLabel} to the customer?{" "}
      {customerMissing && <>Add their email to the {customerLink}. </>}
      {shopMissing && <>Add your valid email in {shopLink}.</>}
    </p>
  );
}
